'use client';

import { useEffect } from 'react';

export default function GoogleTranslate() {
    useEffect(() => {
        (window as any).googleTranslateElementInit = function () {
            new (window as any).google.translate.TranslateElement(
                { pageLanguage: 'sr', autoDisplay: false },
                'google_translate_element'
            );
        };

        if (!document.querySelector('script[src*="translate.google.com/translate_a/element"]')) {
            const s = document.createElement('script');
            s.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
            s.async = true;
            document.head.appendChild(s);
        }

        function fix() {
            const b = document.body;
            const h = document.documentElement;
            // Reset ALL offset properties Google may use
            if (b) {
                b.style.setProperty('top',         '0px', 'important');
                b.style.setProperty('margin-top',  '0px', 'important');
                b.style.setProperty('padding-top', '0px', 'important');
            }
            if (h) {
                h.style.setProperty('top',         '0px', 'important');
                h.style.setProperty('margin-top',  '0px', 'important');
            }
            // Hide the banner iframe
            document.querySelectorAll<HTMLElement>(
                '.goog-te-banner-frame, iframe.goog-te-banner-frame, .skiptranslate'
            ).forEach(el => {
                el.style.setProperty('display',    'none',   'important');
                el.style.setProperty('height',     '0',      'important');
                el.style.setProperty('visibility', 'hidden', 'important');
            });
        }

        fix();

        const mo = new MutationObserver(fix);
        mo.observe(document.body, {
            childList: true, subtree: false,
            attributes: true, attributeFilter: ['style', 'class'],
        });
        mo.observe(document.documentElement, {
            childList: true, subtree: false,
            attributes: true, attributeFilter: ['style', 'class'],
        });

        // Poll every 100ms for 10s, then every 1s forever
        let ticks = 0;
        const fast = setInterval(() => {
            fix();
            if (++ticks >= 100) {
                clearInterval(fast);
                setInterval(fix, 1000);
            }
        }, 100);

        return () => { mo.disconnect(); clearInterval(fast); };
    }, []);

    // Positioned completely off-screen so even if Google makes it visible it can't block anything
    return (
        <div
            id="google_translate_element"
            style={{ position: 'fixed', top: '-9999px', left: '-9999px', width: 0, height: 0, overflow: 'hidden', opacity: 0, pointerEvents: 'none' }}
        />
    );
}
